import PodcastsScreen from './containers/podcastsScreen'

export {default as PodcastsScreenLayout} from './components/podcastsScreenLayout'

export default PodcastsScreen
